import { ChevronAndTitle } from '@rabbit/elements/shared-components';
import VendableSearchContainer from '../../../templates/VendableSearchContainer/VendableSearchContainer';
import { useNavigate } from 'react-router-dom';
import VendableSearchContainerFirestore from '@rabbit/olive/templates/VendableSearchContainerFirestore/VendableSearchContainerFirestore';
import { useContext } from 'react';
import { AppContext } from '@rabbit/app-context';

export function VendableSearchView() {
  const navigate = useNavigate();
  const { config } = useContext(AppContext);
  const isFirestoreSearch =
    config.HOLDINGS.NEW_REGISTRATION_FLOW.SEARCH_VENDABLES_FROM_FIRESTORE;

  return (
    <>
      <ChevronAndTitle
        title={!isFirestoreSearch ? 'Search' : 'Products'}
        onClick={() => navigate(-1)}
      />
      {!isFirestoreSearch ? (
        <VendableSearchContainer />
      ) : (
        <VendableSearchContainerFirestore />
      )}
    </>
  );
}

export default VendableSearchView;
